import { render } from "./addSupplier.vue?vue&type=template&id=e6513424&scoped=true"
import script from "./addSupplier.vue?vue&type=script&lang=js"
export * from "./addSupplier.vue?vue&type=script&lang=js"

import "./addSupplier.vue?vue&type=style&index=0&id=e6513424&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6513424"]])

export default __exports__